module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_15_3.79ae1c64.jpeg";